import React, { useEffect, useState } from "react";
import { useAuth } from "src/App/context/AuthContext";
import "./style.scss";

const View = () => {
  const { user, loading } = useAuth();
  const [signedUrl, setSignedUrl] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    if (loading) return;
    if (!user) {
      setError("You must be logged in to access this content.");
      return;
    }

    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");
    if (!token) {
      setError("No access token provided.");
      return;
    }

    const verify = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/modules/token/verify?token=${encodeURIComponent(token)}`,
          {
            headers: {
              Authorization: `Bearer ${user.session.getIdToken().getJwtToken()}`
            }
          }
        );
        if (!response.ok) {
          const data = await response.json();
          setError(data.error || "Access denied.");
          return;
        }
        const { signedUrl } = await response.json();
        if (!signedUrl) {
          setError("Module not available.");
          return;
        }
        setSignedUrl(signedUrl);
      } catch (e) {
        console.error(e);
        setError("An error occurred. Please try again.");
      }
    };

    verify();
  }, [user, loading]); // eslint-disable-line react-hooks/exhaustive-deps

  if (error) return (
    <div className="view-page">
      <button className="view-back" onClick={() => window.history.back()}>← Back</button>
      <div className="view-content"><p className="view-error">{error}</p></div>
    </div>
  );

  if (!signedUrl) return (
    <div className="view-page">
      <div className="view-content"><p className="view-loading">Loading...</p></div>
    </div>
  );

  return (
    <div className="view-page">
      <button className="view-back" onClick={() => window.history.back()}>← Back</button>
      <iframe
        className="view-iframe"
        src={signedUrl}
        title="Module"
        allow="autoplay; fullscreen; microphone; camera; gyroscope; accelerometer; clipboard-write"
        allowFullScreen
      />
    </div>
  );
};

export default View;
